var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { appointmentNoteTypeLabels } from 'constants/noteType';
import { PageSelect, Select } from 'shared/components';
import { disableAllButTab, enumLabelsAsOptions } from 'shared/utils';
import { useNoteSchemaContext } from 'shared/features/note';
import { TrackedClick } from 'shared/features/analytics';
import { FlaggedContent } from 'flagging/components';
export var NoteTypeSelect = function (_a) {
    var _b;
    var note = _a.note, noteId = _a.noteId, _c = _a.noteTypeLabels, passedLabels = _c === void 0 ? appointmentNoteTypeLabels : _c;
    var _d = useNoteSchemaContext(), noteForm = _d.form, noteType = _d.noteType;
    var labelsAsOptions = enumLabelsAsOptions(passedLabels);
    var isOneOption = labelsAsOptions.length === 1;
    var isReadOnly = !!((_b = note.data) === null || _b === void 0 ? void 0 : _b.signedAt) || isOneOption;
    return (_jsx(FlaggedContent, { flag: "PAGE_SELECT", enabledContent: _jsx(TrackedClick, __assign({ eventName: "Note Type", eventProperties: { spring_doc_id: 'compass016' } }, { children: _jsx(PageSelect, __assign({ label: "Change note template", "data-testid": "selectNoteType", name: "sessionInfo.noteType", register: noteForm.register }, (!noteId && !noteType && { placeholder: 'No note template selected' }), (isReadOnly && {
                pointerEvents: 'none',
                onKeyDown: disableAllButTab,
                isReadOnly: isReadOnly,
            }), { children: labelsAsOptions.map(function (option) { return (_jsx("option", __assign({ value: option.value }, { children: option.label }), option.value)); }) })) })), disabledContent: _jsx(TrackedClick, __assign({ eventName: "Note Type", eventProperties: { spring_doc_id: 'compass016' } }, { children: _jsx(Select, __assign({ "data-testid": "selectNoteType", width: "auto", variant: "headerSelect" }, (isOneOption && { icon: _jsx(_Fragment, {}) }), noteForm.register('sessionInfo.noteType'), (!noteId && { placeholder: 'Select your note template' }), (isReadOnly && {
                pointerEvents: 'none',
                onKeyDown: disableAllButTab, //intercept keyboard navigation but don't stop them from tabbing by.
            }), { children: labelsAsOptions.map(function (option) { return (_jsx("option", __assign({ value: option.value }, { children: option.label }), option.value)); }) })) })) }));
};
